import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { FormattedMessage, useIntl } from 'react-intl';
import { Divider, Grid } from '@material-ui/core';
import { Typography } from '../../components/Typography';
import { Card } from '../../components/Card';
import { Button } from '../../components/Button';
import { IGroupsState, emptyGroup } from '../group/groups.slice';

const useStyles = makeStyles((theme) => ({
  cardWithoutTable: {
    paddingLeft: 24,
    paddingRight: 24,
  },
  cardContentWrapper: {
    // overflow: 'auto',
    // height: '90%',
  },
  cardTitle: {
    fontSize: '1.2rem',
    height: 64,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },
  groupWrapper: {
    height: 'calc(100% - 70px)',
  },
  groupTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  groupTitle: {
    marginBottom: 5,
    fontWeight: 'bold',
  },
  groupMemberName: {
    // width: '40%',
  },
}));

interface IGroupManageCardProps {
  selectGroup: IGroupsState;
  onAddGroup: () => void;
  onEditGroup: (group: any) => void;
  onRemoveGroup: (name: string, callback: () => void) => void;
  onRemoveGroupMember: (memberName: string, callback: () => void) => void;
  handleDeleteGroup: (groupId: string) => void;
  handleDeleteGroupMember: (memberId: string) => void;
}

export const GroupManageCard: React.FC<IGroupManageCardProps> = ({
  selectGroup,
  onAddGroup,
  onEditGroup,
  onRemoveGroup,
  onRemoveGroupMember,
  handleDeleteGroup,
  handleDeleteGroupMember,
}) => {
  const classes = useStyles();
  const intl = useIntl();

  const EachGroup = ({ group }: any) => {
    return (
      <Grid item xs={12} sm={4}>
        <div className={classes.groupTitleWrapper}>
          <Typography variant="body1" className={classes.groupTitle}>
            {group.name}
          </Typography>
          <div>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => onEditGroup(group)}
            >
              <EditIcon fontSize="inherit" />
            </IconButton>
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() =>
                onRemoveGroup(group.name, () => {
                  handleDeleteGroup(group._id);
                })
              }
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        </div>
        <Divider />
        {group.members?.map((member: any, index: number) => {
          const memberName = member?.userId?.profile?.name;
          return (
            <div style={{ display: 'flex' }} key={index}>
              <Typography className={classes.groupMemberName} variant="body2">
                {memberName}
              </Typography>
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() =>
                  onRemoveGroupMember(memberName, () => {
                    handleDeleteGroupMember(member.id);
                  })
                }
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </div>
          );
        })}
      </Grid>
    );
  };

  return (
    <Card customStyles={classes.cardWithoutTable}>
      <div style={{ float: 'right' }}>
        <Button
          id="add-group"
          label={intl.formatMessage({
            id: 'add_group',
          })}
          variant="contained"
          onClick={onAddGroup}
        />
      </div>
      <div className={classes.cardContentWrapper}>
        <Typography variant="h6" className={classes.cardTitle}>
          <FormattedMessage id="groups" />
        </Typography>
        <Grid container spacing={3} className={classes.groupWrapper}>
          {selectGroup.list.data &&
            selectGroup.list.data.map(
              (group: { _id: string; name: string; members: any[] }) => (
                <EachGroup
                  group={group}
                  title={group.name}
                  members={group.members}
                  key={group._id}
                />
              )
            )}
        </Grid>
      </div>
    </Card>
  );
};
